import { useEffect } from 'react';
import { processEventData } from '../utils/processEventData';
import { MESSAGE_EVENT_TYPE } from 'components/shared/XpressId/constants';

export const useXpressIdEvents = ({ onProcessCompleted, onProcessCancelled, onProcessError, onProcessEvents }) => {
    useEffect(() => {
        const receiveMessage = event =>
            processEventData(event, onProcessCompleted, onProcessCancelled, onProcessError, onProcessEvents);
        window.addEventListener(MESSAGE_EVENT_TYPE, receiveMessage, false);

        return () => window.removeEventListener('message', receiveMessage);
    }, [onProcessCompleted, onProcessCancelled, onProcessError, onProcessEvents]);
};
